import React from 'react';
import TreatmentsTemplate from '../treatmentsTemplate/TreatmentsTemplate';

const resourceLinks = [
    {
        title: 'Knee Replacement Surgery',
        link: 'https://healthy.kaiserpermanente.org/health-wellness/health-encyclopedia/he.knee-replacement-surgery.aa14776',
    },
    {
        title: 'Total Knee Replacement',
        link: 'https://orthoinfo.aaos.org/en/treatment/total-knee-replacement/',
    },
    {
        title: 'Knee Replacement Surgery Procedure',
        link: 'https://www.hopkinsmedicine.org/health/treatment-tests-and-therapies/knee-replacement-surgery-procedure',
    },
];

const pageTitle = 'Total Knee Arthroplasty';
const pageSubTitle = 'Total Knee Arthroplasty (TKA) is a surgical procedure used to treat severe knee joint damage, most commonly caused by advanced osteoarthritis.';
const videoKey = 'MCU9nA-9GI8';

const Tka = () => {
    return (
        <TreatmentsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={
                <>
                    <p>
                        In this procedure, the surgeon removes the worn-out or damaged surfaces of the knee
                        and replaces
                        them with artificial components made of metal and high-grade plastic, designed to
                        mimic the
                        movement and function of a healthy knee.
                    </p>
                    <p>
                        This treatment is typically recommended for individuals who suffer from chronic knee
                        pain,
                        stiffness, and loss of mobility that interfere with everyday activities—such as
                        walking,
                        standing, or climbing stairs—and who have not improved with non-surgical options
                        like physical
                        therapy, medications, or joint injections.
                    </p>
                    <p>
                        TKA can also be performed for patients with rheumatoid arthritis, prior fractures,
                        or
                        deformities
                        that affect knee function. The primary goals are to relieve pain, restore knee
                        motion, and
                        improve quality of life. For many patients, TKA allows them to return to activities
                        they had
                        given up due to pain.
                    </p>
                    <p>
                        TKA is considered one of the most successful orthopedic procedures, with high
                        patient
                        satisfaction and a long track record of effectiveness. Most people experience
                        significant
                        improvement in pain and function, and modern implants often last 15 to 20 years or
                        more.
                    </p>
                </>
            }
            videoKey={videoKey}
            resourceLinks={resourceLinks}
            pageType="treatment"
        />
    );
};

export default Tka;